import * as React from 'preact/compat'
import SVG from '../SVG'
import { useEffect } from 'preact/compat'

export default ({
  title,
  platforms,
  collapsible,
  opened,
  type
}) => {
  const [collapsed, setCollapsed] = React.useState(collapsible && !opened)

  useEffect(() => {
    setCollapsed(collapsible && !opened)
  }, [type])
  const toggleCollapsed = () => {
    if (collapsible) {
      setCollapsed(!collapsed)
    }
  }

  let icon = <></>
  if (collapsible) {
    icon = <SVG i={collapsed ? 'sg/chevron-down' : 'sg/chevron-up'} style='display: block; width: 24px; height: 24px;'/>
  }

  return <div style='margin-bottom: 32px'>
    <span
      style={{
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        columnGap: '12px',
        color: !collapsible ? 'var(--brand-red)' : 'var(--v9-color-text-header)'
      }}
      onClick={toggleCollapsed}
    >{icon} {title}</span>
    <div
      style={{
        columnCount: 2,
        display: collapsed ? 'none' : 'block',
        marginTop: '12px'
      }}
    >
      {platforms}
    </div>
  </div>
}
